import * as types from "../constants";

const initialState = {
  doorlockListTotal: 0,
  doorlockListItems: [],
  currentPageNumber: 1,
  paginationItem: {
    offset: 0,
    limit: 3000, //max 데이터 개수
  },
  filterItem: {
    buildingId: "",
    name: "",
    serial: "",
    type: "",
    status: "",
    fwType: "",
    fwVersion: "",
  },
};

const DoorlockTileListReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.INIT_DOORLOCK_TILE_LIST_STATE:
      return {
        ...state,
        doorlockListTotal: 0,
        doorlockListItems: [],
        currentPageNumber: 1,
        paginationItem: {
          offset: 0,
          limit: 10,
        },
        filterItem: {
          buildingId: "",
          name: "",
          serial: "",
          type: "",
          status: "",
          fwType: "",
          fwVersion: "",
        },
      };
    case types.SET_DOORLOCK_TILE_LIST:
      return {
        ...state,
        doorlockListTotal: action.payload.total,
        doorlockListItems: action.payload.items,
      };
    case types.SET_DOORLOCK_TILE_LIST_CURRENT_PAGE_NUMBER:
      return {
        ...state,
        currentPageNumber: action.payload,
      };
    case types.SET_DOORLOCK_TILE_PAGINATION_ITEM:
      return {
        ...state,
        paginationItem: action.payload,
      };
    case types.SET_DOORLOCK_TILE_FILTER_ITEM:
      return {
        ...state,
        filterItem: action.payload,
      };
    default:
      return state;
  }
};

export default DoorlockTileListReducer;
